<!-- 派车 -->

<template>
  <div class="car-dispatch-dialog">
    <w-dialog ref="dialogRef" class="carmeet-add-dialog" title="派车" width="60%" top="10vh" confirmText="确认派车"
      @wConfirm="handleSure">
      <el-form class="add-form" ref="formRef" :model="ruleForm" :rules="rules" labelPosition="top">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="车牌" prop="plate">
              <el-input v-model="currentRow.plate" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出发点" prop="departure_place">
              <el-autocomplete v-model="ruleForm.departure_place" :fetch-suggestions="startQuerySearch" clearable
                class="inline-input w-50" placeholder="请输入出发点" @select="startHandleSelect">
                <template #default="{ item }">
                  <div class="value">{{ item }}</div>
                </template>
              </el-autocomplete>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="目的地" prop="arrival_place">
              <el-autocomplete v-model="ruleForm.arrival_place" :fetch-suggestions="startQuerySearch" clearable
                class="inline-input w-50" placeholder="请输入目的地" @select="destinationSelect">
                <template #default="{ item }">
                  <div class="value">{{ item }}</div>
                </template>
              </el-autocomplete>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="途经点" prop="stopover_place">
              <el-input v-model="ruleForm.stopover_place" placeholder="请输入途经点" clearable></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item label="发车时间" prop="departure_time">
              <!-- <el-date-picker v-model="ruleForm.departure_time" type="datetime" placeholder="请选择发车时间"
                format="YYYY-MM-DD HH:mm" value-format="YYYY-MM-DD HH:mm" clearable
                :disabled-date="disabledDate" /> -->
              <el-col :span="12" style="padding: 0;width: 100%;">
                <el-date-picker v-model="ruleForm.departDate" type="date" format="YYYY-MM-DD" value-format="YYYY-MM-DD"
                  placeholder="请选择日期" :disabled-date="disabledDate" />
              </el-col>
              <el-col :span="12" style="padding-right: 0;width: 100%;">
                <el-time-picker v-model="ruleForm.departTime" format="HH:mm" value-format="HH:mm" placeholder="请选择时间" />
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="预计抵达时间" prop="arrival_time">
              <!-- <el-date-picker v-model="ruleForm.arrival_time" type="datetime" placeholder="请选择预计抵达时间"
                format="YYYY-MM-DD HH:mm" value-format="YYYY-MM-DD HH:mm" clearable :disabled-date="disabledDate" /> -->
              <el-col :span="12" style="padding: 0;width: 100%;">
                <el-date-picker v-model="ruleForm.arrivalDate" type="date" format="YYYY-MM-DD" value-format="YYYY-MM-DD"
                  placeholder="请选择日期" :disabled-date="disabledDate" style="width: 100%" />
              </el-col>
              <el-col :span="12" style="padding-right: 0;width: 100%;">
                <el-time-picker v-model="ruleForm.arrivalTime" format="HH:mm" value-format="HH:mm" placeholder="请选择时间"
                  style="width: 100%" />
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="乘车人数" prop="count">
              <el-input v-model="ruleForm.count" type="number" placeholder="请输入乘车人数" oninput="if(value<0)value=0"
                clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="司机" prop="driver">
              <el-select v-model="ruleForm.driver" :remote-method="getDriverOptions" filterable remote clearable
                placeholder="请选择司机" :loading="isLoading">
                <el-option v-for="item in driverOptions" :key="item.u_id" :label="item.u_name" :value="item.u_id">
                  <el-row>
                    <el-col :span="8">{{ item.u_name }}</el-col>
                    <el-col :span="10">{{ item.u_tel }}</el-col>
                    <el-col :span="6">{{ item.du_name }}</el-col>
                  </el-row>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="约车人姓名" prop="contact_name">
              <el-input v-model="ruleForm.contact_name" placeholder="请输入约车人姓名" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="约车人电话" prop="contact_mobile">
              <el-input v-model="ruleForm.contact_mobile" placeholder="请输入约车人电话" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </w-dialog>
  </div>
</template>

<script>
import { ref, reactive, } from "vue";
import { VipApi, } from "@/plugins/api.js";
import { ElMessage, } from "element-plus";

export default {
  emits: ["submit"],
  components: {},
  setup(props, { emit }) {
    const dialogRef = ref(null);  // 弹框对象
    const currentRow = ref('');  // 当前行数据
    const driverOptions = ref([]); // 司机列表
    const isLoading = ref(false); // 司机列表加载状态
    const formRef = ref(null);
    const ruleForm = ref({
      departure_place: '',  // 出发点
      arrival_place: '',  // 目的地
      // stopover_place: '',  // 途经点
      departure_time: '',  // 发车时间
      departDate: '',  // 发车日期
      departTime: '',  // 发车时间
      arrival_time: '',  // 预计抵达时间
      arrivalDate: '',  // 预计抵达日期
      arrivalTime: '',  // 预计抵达时间
      count: '',  // 乘车人数
      contact_name: '',  // 约车人姓名
      contact_mobile: '',  // 约车人电话
      driver: '',  // 司机
    });
    const rules = reactive({
      departure_place: [
        { required: true, message: "请输入出发点", trigger: "blur", },
      ],
      arrival_place: [
        { required: true, message: "请输入目的地", trigger: "blur", },
      ],
      count: [
        { required: true, message: "请输入乘车人数", trigger: "blur", },
        // { type: "number", min: 1, max: 100, message: "乘车人数在1到100之间", trigger: "blur" },
      ],
      driver: [
        { required: true, message: "请选择司机", trigger: "change", },
      ],
      contact_name: [
        { required: true, message: "请输入约车人姓名", trigger: "blur", },
      ],
      contact_mobile: [
        { required: true, message: "请输入约车人电话", trigger: "blur", },
        // { pattern: /^1[3-9]\d{9}$/, message: "请输入正确的手机号", trigger: "blur" },
      ],
    });

    /**
     * 
     * 打开对话框
     * 
     * **/
    const openDialog = (row) => {
      currentRow.value = row;
      ruleForm.value.departure_place = '';
      ruleForm.value.arrival_place = '';
      // ruleForm.value.stopover_place = '';
      ruleForm.value.departure_time = '';
      ruleForm.value.departDate = new Date().toISOString().slice(0, 10); // 设置为今天的日期
      ruleForm.value.departTime = '';
      ruleForm.value.arrival_time = '';
      ruleForm.value.arrivalDate = new Date().toISOString().slice(0, 10); // 设置为今天的日期
      ruleForm.value.arrivalTime = '';
      ruleForm.value.count = '';
      ruleForm.value.driver = '';
      ruleForm.value.contact_name = '';
      ruleForm.value.contact_mobile = '';
      // 默认显示司机
      if (row.driver_list.length > 0) {
        ruleForm.value.driver = row.driver_list[0].u_id;
        getDriverOptions(row.driver_list[0].u_name);
      }
      dialogRef.value.show();
    }
    /**
     * 
     * 关闭对话框
     * 
     * **/
    const closeDialog = () => {
      dialogRef.value.close();
    }
    /**
     * 
     * 关闭对话框加载状态
     * 
     * **/
    const closeDialogLoading = () => {
      dialogRef.value.isLoading = false;
    }

    /**
     * 
     * 常用出发点
     * 
     **/
    const startQuerySearch = (query, cb) => {
      VipApi.getCarPlaceList().then(res => {
        if (res.Code == 200) {
          cb(res.Data);
        } else {
          ElMessage.error(res.Message);
        }
      })
    }
    /**
     * 
     * 选择常用出发点
     * 
     **/
    const startHandleSelect = (item) => {
      ruleForm.value.departure_place = item;
    }
    /**
     * 
     * 选择常用目的地
     * 
     **/
    const destinationSelect = (item) => {
      ruleForm.value.arrival_place = item;
    }
    /**
     * 
     * 获取司机
     * 
     * **/
    const getDriverOptions = (query) => {
      VipApi.searchCarDiver({ keyword: query, }).then((res) => {
        if (res.Code == 200) {
          driverOptions.value = res.Data;
        }
      });
    }
    /**
     * 
     * 禁用过去的日期
     * 
     * **/
    const disabledDate = (time) => {
      return time.getTime() < Date.now() - 86400000; // Date.now() - 86400000 将当前时间减去一天的毫秒数，确保只能选择今天及以后

    }
    /**
     * 
     * 确认提交
     * 
     * **/
    const handleSure = () => {
      formRef.value.validate((valid) => {
        if (valid) {
          if (!ruleForm.value.departDate) {
            ElMessage.error('请选择发车日期！');
            return;
          }
          if (!ruleForm.value.departTime) {
            ElMessage.error('请选择发车时间！');
            return;
          }
          if (!ruleForm.value.arrivalDate) {
            ElMessage.error('请选择预计抵达日期！');
            return;
          }
          if (!ruleForm.value.arrivalTime) {
            ElMessage.error('请选择预计抵达时间！');
            return;
          }
          ruleForm.value.arrival_time = `${ruleForm.value.arrivalDate} ${ruleForm.value.arrivalTime}`;
          ruleForm.value.departure_time = `${ruleForm.value.departDate} ${ruleForm.value.departTime}`;
          let params = {
            car_id: currentRow.value.id,
            ...ruleForm.value,
          };
          // console.log('ruleForm', ruleForm.value, params);
          dialogRef.value.isLoading = true;
          VipApi.addCarDispatch(params).then((res) => {
            dialogRef.value.isLoading = false;
            if (res.Code == 200) {
              ElMessage.success('派车成功!');
              closeDialog();
              emit("submit");
            } else {
              ElMessage.error(res.Message);
            }
          });
        }
      })
    }


    return {
      openDialog,
      dialogRef,
      closeDialog,
      closeDialogLoading,
      currentRow,
      formRef,
      ruleForm,
      rules,
      startQuerySearch,
      startHandleSelect,
      handleSure,
      destinationSelect,
      driverOptions,
      getDriverOptions,
      isLoading,
      disabledDate,
    };
  },
};
</script>

<style lang="scss">
.car-dispatch-dialog {
  .el-autocomplete {
    width: 100%;
  }
}
</style>